// extracted by mini-css-extract-plugin
export default {"list":"styles_list__fxIjU","list_item":"styles_list_item__6ntBZ"};